import { useCatalogUrl } from '@bluheadless/ui-logic/src/hooks/useCatalogUrl'
import { useMenus } from '@bluheadless/ui-logic/src/providers/menus'
import LinkUnstyled from '../../molecules/link/link-unstyled'

const SeoNavLink = ({ url, type, children }) => {
	const productUrl = useCatalogUrl(url)

	let href

	if (type === 'product') {
		href = productUrl
	} else {
		href = url
	}

	return href ? <LinkUnstyled href={href}>{children}</LinkUnstyled> : <p>{children}</p>
}

const SeoMenuElement = ({ children }) => {
	return children?.map((child) => {
		const hasChildren = child?.children?.length > 0
		return (
			<li key={child.id}>
				<SeoNavLink url={!hasChildren ? child.path ?? child.urlKey ?? child.url : null} type={child.type}>
					{child.title}
				</SeoNavLink>
				{hasChildren && (
					<ul>
						<SeoMenuElement>{child.children}</SeoMenuElement>
					</ul>
				)}
			</li>
		)
	})
}

const SeoMenu = () => {
	const { mainMenu } = useMenus()

	return mainMenu?.length > 0 ? (
		<div style={{ display: 'none' }}>
			{mainMenu?.map(({ children, id, title }) => {
				// recursively render menu children items
				return (
					<div key={id}>
						<p>{title}</p>
						<ul>
							<SeoMenuElement>{children}</SeoMenuElement>
						</ul>
					</div>
				)
			})}
		</div>
	) : null
}

export default SeoMenu
